import React from 'react'
import { Block, ImageWithContent } from '@components'

const DatoCmsImageWithContent = ({
  paddingTop,
  paddingBottom,
  background,
  backgroundStyle,
  ...props
}) => {
  return (
    <Block
      gutters={props.width !== 'Full Width'}
      paddingTop={paddingTop}
      paddingBottom={paddingBottom}
      background={background}
      backgroundStyle={backgroundStyle}
    >
      <ImageWithContent elevated {...props} />
    </Block>
  )
}

export default DatoCmsImageWithContent
